/**
 * Mainbeauty — lightbox video học thử ([data-pi-video]) + popup gate đăng ký ([data-pi-lock]).
 */
import { bindPopupClose, closePopupOnLead } from "./mainbt-popup-form.js";

function initVideoModal() {
  const modal = document.querySelector("[data-pi-vmodal]");
  if (!modal) return;

  const frame = modal.querySelector("[data-pi-vmodal-frame]");
  const title = modal.querySelector("[data-pi-vmodal-title]");

  const close = () => {
    modal.classList.remove("is-open");
    frame.removeAttribute("src"); // xoá src để video dừng hẳn
    document.body.classList.remove("pi-noscroll");
  };

  const open = (id, label) => {
    frame.src =
      "https://www.youtube-nocookie.com/embed/" +
      encodeURIComponent(id) +
      "?autoplay=1&rel=0&modestbranding=1";
    title.textContent = label || "";
    modal.classList.add("is-open");
    document.body.classList.add("pi-noscroll");
  };

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-pi-video]");
    if (!trigger) return;
    e.preventDefault();
    open(
      trigger.getAttribute("data-pi-video"),
      trigger.getAttribute("data-pi-video-title")
    );
  });

  bindPopupClose(modal, "[data-pi-vmodal-box]", "[data-pi-vmodal-close]", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) close();
  });
}

// Mở khoá là quyết định phía server (pi_course_modules) — gửi form xong KHÔNG tự đổi badge.
function initGate() {
  const gate = document.querySelector("[data-pi-gate]");
  if (!gate) return;

  // Ô "khóa học quan tâm" chỉ nhận MÃ cấp độ; tên buổi học đi vào ô Nội dung.
  const courseInput = gate.querySelector('input[name="course"]');
  const messageInput = gate.querySelector('input[name="message"]');

  const close = () => {
    gate.classList.remove("is-open");
    document.body.classList.remove("pi-noscroll");
  };

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-pi-lock]");
    if (!trigger) return;
    // Badge khóa nằm trong <summary>; đừng toggle accordion theo.
    e.preventDefault();
    e.stopPropagation();

    // Tên buổi chỉ đi theo lead cho sales, không hiện trong popup.
    const label = trigger.getAttribute("data-pi-lock") || "";
    if (courseInput) {
      courseInput.value = trigger.getAttribute("data-pi-lock-course") || "";
    }
    if (messageInput) messageInput.value = label;

    gate.classList.add("is-open");
    document.body.classList.add("pi-noscroll");
  });

  bindPopupClose(gate, "[data-pi-gate-box]", "[data-pi-gate-close]", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && gate.classList.contains("is-open")) close();
  });

  // Gửi thành công: đóng gate, nhường chỗ cho modal thông báo chung.
  closePopupOnLead(gate, close);
}

// Video chính của trang bài học: ảnh trước, iframe chỉ dựng khi khách thật sự bấm play.
function initEmbedFacade() {
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-pi-embed]");
    if (!trigger) return;
    e.preventDefault();

    const id = trigger.getAttribute("data-pi-embed");
    const holder = trigger.parentElement;
    if (!id || !holder) return;

    const frame = document.createElement("iframe");
    frame.src =
      "https://www.youtube-nocookie.com/embed/" +
      encodeURIComponent(id) +
      "?autoplay=1&rel=0&modestbranding=1";
    frame.title = trigger.getAttribute("data-pi-embed-title") || "";
    frame.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    frame.allowFullscreen = true;
    holder.replaceChildren(frame);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initVideoModal();
  initGate();
  initEmbedFacade();
});
